export default {
  platformList : state => state.nav.navConfig.platformList,
  presetConfigList: state => state.nav.navConfig.presetConfigList,
  userConfig : state => state.nav.navConfig.userConfig
}



// WEBPACK FOOTER //
// ./src/store/getters.js